// Version : 0.0.1
// LastEdit : KARTHEESWARAN
// MODFIED DATE:12-11-2025
//Last ADD : REMOVE COMMENTED LINES

import { makeApiCall } from '../../_common/api.utils';
import { API_URL } from '../../const';

/************ GET ATTENDANCE REPORT LIST START **********************/
export const attendanceReportListGet = (listData: any) => {
	const data = {
		GetAttendanceReportToken: listData,
	};
	const url = `${API_URL}attendanceBasedOfficerReport`;
	return makeApiCall(url, data);
};
/************ GET ATTENDANCE REPORT LIST END **********************/
